import { render, staticRenderFns } from "./RegiaoAnalise.vue?vue&type=template&id=6325a1fa&scoped=true&lang=pug"
import script from "./RegiaoAnalise.vue?vue&type=script&lang=js"
export * from "./RegiaoAnalise.vue?vue&type=script&lang=js"
import style0 from "./RegiaoAnalise.vue?vue&type=style&index=0&id=6325a1fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6325a1fa",
  null
  
)

export default component.exports